import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  }
});

// supabase-js dispatches onAuthStateChange asynchronously (deferred to avoid
// deadlocks), so `await supabase.auth.setSession(...)` can resolve before
// AuthContext's listener has actually updated its `user` state. Navigating
// right after setSession() then races ProtectedRoute, which still sees no
// user and bounces back to the login page. Call this first so the redirect
// only happens once auth state has genuinely propagated.
export const waitForAuthSync = () => new Promise((resolve) => {
  let settled = false;
  const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
    if (settled) return;
    settled = true;
    subscription?.unsubscribe();
    resolve(session);
  });
  setTimeout(() => {
    if (settled) return;
    settled = true;
    subscription?.unsubscribe();
    resolve(null);
  }, 2000);
});
